import React, { Component } from 'react';
import TheReturnView from './JournalTheReturnView';
import { connect } from 'react-redux';
import * as journalActions from 'actions/journalActions';
import { selectFields } from './StepFields/TheReturn';

class TheReturn extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    const {
      getReturnRequest,
      match: { params },
    } = this.props;
    getReturnRequest(params.id, params.day);
  }

  componentDidUpdate(prevProps) {
    if (
      (!prevProps.returnData && this.props.returnData) ||
      (prevProps.returnData && prevProps.returnData != this.props.returnData)
    ) {
      const { message_morning, message_today, message_evening } = this.props.returnData;
      this.setState({ message_morning, message_today, message_evening });
    }
  }

  handleChange = evt => {
    this.setState({ [evt.target.name]: evt.target.value });
  };

  saveDay = () => {
    const {
      createDayTheReturnRequest,
      match: { params },
      day,
      returnData: { id },
    } = this.props;
    const { message_morning, message_today, message_evening } = this.state;

    createDayTheReturnRequest(id, {
      message_morning,
      message_today,
      message_evening,
      status: 'completed',
    });
  };

  render() {
    const { day, returnData } = this.props;
    if (!returnData) return null;
    const { message_morning, message_today, message_evening } = this.state;
    const stepFields = selectFields(+day);

    return (
      <TheReturnView
        {...this.props}
        saveDay={this.saveDay}
        stepFields={stepFields}
        currentDay={day}
        message_morning={message_morning}
        message_today={message_today}
        message_evening={message_evening}
        handleChange={this.handleChange}
        date={returnData.date}
      />
    );
  }
}

function mapStateToProps(state) {
  return {
    returnData: state.journalReducer.returnData,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    createDayTheReturnRequest: (id, returnData) =>
      dispatch(journalActions.createDayTheReturnRequest(id, returnData)),
    getReturnRequest: (journal_id, day) =>
      dispatch(journalActions.getReturnRequest({ journal_id, day })),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(TheReturn);
